import { useCallback, useEffect, useRef } from 'react';
import { ScrollView } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';

import { useImageHandlingViewModel } from '@v2/components/imageHandling/viewmodels/useImageHandlingViewModel';
import { ImageContext } from '@v2/components/imageHandling/types/types';
import { ImagesContainerProps } from '@v2/pages/common/components/ImagesContainer/ImagesContainer';
import { KEYS_TAGS } from '@components/imageHandling/common';

interface UseManageImagesContainerParams
  extends Pick<ImagesContainerProps, 'documentRetrieveId' | 'documentRetrieveKey' | 'panelViewMode' | 'retrieveAllDocuments'> {}

export const useManageImagesContainer = ({
  documentRetrieveId,
  documentRetrieveKey,
  panelViewMode,
  retrieveAllDocuments = true,
}: UseManageImagesContainerParams) => {
  const imageScroll = useRef<ScrollView | null>(null);

  const imageContext: ImageContext =
    documentRetrieveKey != null && documentRetrieveId != null
      ? { scopeId: KEYS_TAGS[documentRetrieveKey as keyof typeof KEYS_TAGS], scopeReferenceId: documentRetrieveId }
      : {};

  const {
    state: { imagesDocuments },
    actions: { loadImagesDocuments },
  } = useImageHandlingViewModel({ imageContext, retrieveAllDocuments });

  useEffect(() => {
    if (imageScroll && imageScroll.current && !panelViewMode) {
      imageScroll.current.scrollToEnd({ animated: false });
    }
  }, [imageScroll, imagesDocuments.length]);

  useFocusEffect(
    useCallback(() => {
      loadImagesDocuments();
    }, [documentRetrieveId, documentRetrieveKey])
  );

  return { imagesDocuments };
};
